import React from 'react';
import createReactClass from 'create-react-class';

import debounce from 'lodash/debounce';
import { withContainer } from 'core/cache';

import getDimensions from '../helpers/getDimensions';
import getFilterSelectionFromUrl from '../helpers/getFilterSelectionFromUrl';

import Filters from '../components/filters';

const FiltersContainer = createReactClass({
  getInitialState() {
    return {
      dropdown: null,
      dropdownPosition: 'left',
      filter: null,
      hasLeftHandle: false,
      hasRightHandle: false,
      isLoadingContent: false,
      selection: getFilterSelectionFromUrl(this.props),
      scroller: null,
    };
  },

  componentDidMount() {
    this.updateUrl = debounce(this.updateUrl, 1000);
    window.addEventListener('filterContent.loaded', this.handleLoad);
  },

  componentWillUnmount() {
    window.removeEventListener('filterContent.loaded', this.handleLoad);
  },

  handleClearButtonClick() {
    this.setState({ selection: {} }, this.onPostSelectionChange);
  },

  handleDropdownToggle({ isOpen, menuListRef, menuRef }) {
    if (!isOpen) return;

    this.setState({
      dropdown: menuListRef.current,
      filter: menuRef.current,
    }, this.checkIfFilterOffScreen);
  },

  handleLoad() {
    this.setState({ isLoadingContent: false });
  },

  handleHandleClick(direction) {
    const { scroller } = this.state;
    const { width } = getDimensions(scroller);
    const offset = direction === 'left' ? width * -0.6 : width * 0.6;

    scroller.scrollLeft += offset;
  },

  handleScroll() {
    this.setHandleState();
  },

  handleScrollerUpdate(scroller) {
    this.setState({ scroller });
    this.setHandleState();
  },

  handleSelectionUpdate({ isSelected, key, value }) {
    this.setState(({ selection }) => {
      const currentValues = selection[key] || [];

      const newValues = isSelected
        ? [...currentValues, value]
        : currentValues.filter((currentValue) => currentValue !== value);

      return { selection: { ...selection, [key]: newValues } };
    }, this.onPostSelectionChange);
  },

  onPostSelectionChange() {
    this.updateUrl();
    this.checkIfFilterOffScreen();
    this.setHandleState();
  },

  setHandleState() {
    this.setState(({ scroller }) => {
      const { scrollLeft, scrollRight, scrollWidth } = getDimensions(scroller);

      return {
        hasLeftHandle: Boolean(scrollLeft),
        hasRightHandle: Math.round(scrollRight) < scrollWidth, // TODO: check widths
      };
    });
  },

  HANDLE_WIDTH: 56,

  checkIfFilterOffScreen() {
    const {
      dropdown,
      filter,
      hasLeftHandle,
      hasRightHandle,
      scroller,
    } = this.state;

    if (!filter) return;

    const {
      offsetLeft: filterLeft,
      offsetRight: filterRight,
      width: filterWidth,
    } = getDimensions(filter);

    const { scrollLeft, scrollRight, width: scrollerWidth } = getDimensions(scroller);

    // check if dropdown is off screen in both directions
    const { width: dropdownWidth } = getDimensions(dropdown);
    const dropdownLeft = filterRight - dropdownWidth;
    const dropdownRight = filterLeft + dropdownWidth;
    const isDropdownOffScreenLeft = dropdownLeft < scrollLeft;
    const isDropdownOffScreenRight = dropdownRight > scrollRight;
    const { offsetRight: scrollWidth } = getDimensions(scroller.lastChild);
    const isDropdownPastEnd = isDropdownOffScreenRight && dropdownRight > scrollWidth;

    if (isDropdownOffScreenLeft && isDropdownOffScreenRight) {
      return isDropdownPastEnd ? this.scrollRight() : this.scrollLeft();
    }

    const leftHandle = hasLeftHandle ? this.HANDLE_WIDTH : 0;
    const isFilterOffScreenLeft = filterLeft - leftHandle < scrollLeft;

    if (filterWidth >= scrollerWidth || isFilterOffScreenLeft) {
      return this.scrollLeft();
    }

    const rightHandle = hasRightHandle ? this.HANDLE_WIDTH : 0;
    const isFilterOffScreenRight = filterRight + rightHandle > scrollRight;

    if (isFilterOffScreenRight) {
      return this.scrollRight();
    }

    this.setState({ dropdownPosition: isDropdownOffScreenRight ? 'right' : 'left' });
  },

  scrollLeft() {
    const { filter, scroller } = this.state;
    const { offsetLeft: filterLeft } = getDimensions(filter);

    scroller.scrollLeft = filterLeft - this.HANDLE_WIDTH;
    this.setState({ dropdownPosition: 'left' });
  },

  scrollRight() {
    const { filter, scroller } = this.state;
    const { offsetRight: filterRight } = getDimensions(filter);
    const { scrollRight } = getDimensions(scroller);

    scroller.scrollLeft += filterRight + this.HANDLE_WIDTH - scrollRight;
    this.setState({ dropdownPosition: 'right' });
  },

  updateUrl() {
    const { history } = this.props;
    const search = new URLSearchParams(history.location.search).get('search');
    const params = new URLSearchParams({ search });

    Object.entries(this.state.selection).forEach(([key, values]) => {
      const name = `${key}[]`;

      values.forEach((value) => params.append(name, value));
    });

    this.setState({ isLoadingContent: true });
    history.replace({ search: params.toString() });
    window.dispatchEvent(new Event('popstate'));
  },

  render() {
    const { filters } = this.props;

    const {
      dropdownPosition,
      hasLeftHandle,
      hasRightHandle,
      isLoadingContent,
      selection,
    } = this.state;

    return (
      <Filters
        dropdownPosition={dropdownPosition}
        filters={filters.data}
        hasLeftHandle={hasLeftHandle}
        hasRightHandle={hasRightHandle}
        isLoading={filters.status !== 'success'}
        isLoadingContent={isLoadingContent}
        onClearButtonClick={this.handleClearButtonClick}
        onDropdownToggle={this.handleDropdownToggle}
        onHandleClick={this.handleHandleClick}
        onScroll={this.handleScroll}
        onScrollerUpdate={this.handleScrollerUpdate}
        onSelectionUpdate={this.handleSelectionUpdate}
        selection={selection}
      />
    );
  },
});

export default withContainer(FiltersContainer, {
  cache: {
    filters: {
      getMockedResponse: () => ({ data: [] }),
      initialData: [],
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/learner/search_filters',
    },
  },
  hasRouter: true,
});
